import { Stack } from '@mui/material';
import InputSettings from '@/components/editor/settings/InputSettings';
import SettingCard from '@/components/SettingCard';
import ClassSettings from './ClassSettings';
import InputIconSettings from './InputIconSettings';

const NumberInputSettings = () => {
  return (
    <Stack spacing={2}>
      <SettingCard title="Clases CSS">
        <ClassSettings />
      </SettingCard>
      <InputSettings />
      <InputIconSettings />
    </Stack>
  );
};

export default NumberInputSettings;
